'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _LoginSignup = require('./LoginSignup.scss');

var _LoginSignup2 = _interopRequireDefault(_LoginSignup);

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _reactIntl = require('react-intl');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _session = require('redux/modules/session');

var sessionActions = _interopRequireWildcard(_session);

var _info = require('redux/modules/info');

var _dtac = require('redux/modules/dtac');

var _profile = require('redux/modules/profile');

var _push = require('redux/modules/push');

var _reactRouterRedux = require('react-router-redux');

var _reactFacebookLogin = require('react-facebook-login');

var _reactFacebookLogin2 = _interopRequireDefault(_reactFacebookLogin);

var _reactGoogleLogin = require('react-google-login');

var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);

var _WeiboButton = require('components/ProviderButtons/WeiboButton');

var _WeiboButton2 = _interopRequireDefault(_WeiboButton);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _validation = require('utils/validation');

var _helpers = require('utils/helpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Signup: {
    displayName: 'Signup'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Nav/Signup.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import MobileConnectButton from 'components/MobileConnectButton/MobileConnectButton';


var Signup = _wrapComponent('Signup')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.session.user,
    isLoggedIn: state.session.isLoggedIn,
    signingUp: state.session.signingUp,
    sessionData: state.session.data,
    withPromo: state.session.withPromo,
    oldPromo: state.session.oldPromo,
    dtac_mobile: state.dtac.phone,
    promoInput: state.session.promoInput,
    settingSessionData: state.session.settingSessionData,
    loadingSessionData: state.session.loadingSessionData,
    // isOpenSignup: state.session.openSignup,
    // isOpenLoginSignup: state.session.openLoginSignup,
    callback: state.session.loginSignupCallback,
    messages: state.language.messages,
    enabledLogins: state.info.siteConfigs.enabledLogins,
    locale: state.language.locale,
    mobileRedirectLogin: state.info.siteConfigs.mobileRedirectLogin,
    desktopRedirectLogin: state.info.siteConfigs.desktopRedirectLogin
  };
}, (0, _extends3.default)({}, sessionActions, { sendPromo: _dtac.sendPromo, updateProfile: _profile.updateProfile, push: _reactRouterRedux.push, loadUserConfig: _info.loadUserConfig, requestPermission: _push.requestPermission })), _dec2 = (0, _reactCssModules2.default)(_LoginSignup2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Signup, _Component);

  function Signup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Signup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Signup.__proto__ || (0, _getPrototypeOf2.default)(Signup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // errorEmail: false,
      // errorFirstname: false,
      // errorLastname: false,
      // errorPassword: false,
      errorMessage: '',
      emailError: false,
      emailErrorTemplateId: '',
      emailErrorTemplateValues: '',
      passwordError: false,
      passwordErrorTemplateId: '',
      passwordErrorTemplateValues: '',
      firstNameError: false,
      firstNameErrorTemplateId: '',
      firstNameErrorTemplateValues: '',
      lastNameError: false,
      lastNameErrorTemplateId: '',
      lastNameErrorTemplateValues: ''
    }, _this.onChangePromo = function (e) {
      // this.setState({promo: e.target.value});
      _this.props.setPromoInput(e.target.value);
      var value = e.target.value;
      setTimeout(function () {
        return _this.checkPromo(value);
      }, 1000);
    }, _this.checkPromo = function (promo) {
      if (promo === _this.props.promoInput) {
        _this.props.setSessionData({ promo: promo }).then(function () {
          _this.props.loadSessionData();
        });
      }
    }, _this.facebookCallback = function (response) {
      if (!response.accessToken) return;
      _this.props.facebookLogin(response.accessToken).then(_this.signedUp);
    }, _this.googleCallback = function (response) {
      _this.props.googleLogin(response.getAuthResponse().id_token).then(_this.signedUp);
    }, _this.mobileConnectCallback = function (response) {
      _this.props.mobileConnectLogin(response).then(_this.signedUp);
    }, _this.weiboCallback = function (response) {
      if (response.error) {
        _this.setState({
          errorMessage: response.error_description
        });
        return;
      }
      _this.props.weiboLogin(response).then(_this.signedUp);
    }, _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.validateForm()) {
        var data = {
          email: _this.refs.email.value,
          dtac_mobile: _this.props.dtac_mobile || undefined
        };
        if (_this.props.allowGuest) {
          data.isGuest = true;
        } else {
          data.name = { first: _this.refs.firstname.value, last: _this.refs.lastname.value };
          data.password = _this.refs.password.value;
        }
        _this.props.signup(data).then(_this.signedUp).catch(function (result) {
          _this.setState({ errorMessage: result.message });
          if (result.message === 'Email is already used.') _this.props.onSwitchToLogin(_this.refs.email.value);
        });
      }
    }, _this.validateForm = function () {
      var email = _this.refs.email.value;
      var password = _this.refs.password.value;
      var lastName = _this.refs.lastname.value;
      var firstName = _this.refs.firstname.value;
      var data = {
        email: {
          value: email,
          required: true,
          format: 'email',
          label: _this.props.messages['signup.email.placeholder']
        }
      };
      if (!_this.props.allowGuest) {
        data.password = {
          value: password,
          required: true,
          format: 'password',
          label: _this.props.messages['signup.password.placeholder']
        };
        data.firstName = {
          value: firstName,
          required: true,
          label: _this.props.messages['signup.first_name.placeholder']
        };
        data.lastName = {
          value: lastName,
          required: true,
          label: _this.props.messages['signup.last_name.placeholder']
        };
      }
      var validatedData = (0, _validation.validateForm)(data);
      (0, _keys2.default)(validatedData).map(function (field) {
        if (field === 'formError') return;
        _this.setState((0, _defineProperty3.default)({}, field + 'Error', validatedData[field].error));
        _this.setState((0, _defineProperty3.default)({}, field + 'ErrorTemplateId', validatedData[field].templateId));
        _this.setState((0, _defineProperty3.default)({}, field + 'ErrorTemplateValues', validatedData[field].templateValues));
      });
      if (validatedData.formError) {
        return false;
      }
      return true;
    }, _this.continueWithoutPromo = function () {
      if (_this.props.callback) {
        _this.props.callback({ message: 'cancel' });
      }
    }, _this.signedUp = function () {
      // this.refs.email.value = '';
      // this.refs.firstname.value = '';
      // this.refs.lastname.value = '';
      // this.refs.password.value = '';
      _this.props.loadUserConfig();
      // this.setState({
      //   errorEmail: false,
      //   errorFirstname: false,
      //   errorLastname: false,
      //   errorPassword: false,
      //   errorMessage: '',
      // });
      if (_this.props.callback) {
        _this.props.callback();
      }
      if (_this.props.isLoggedIn) {
        _this.props.loggedIn(_this.props.user._id);
        _this.props.requestPermission();
      }
    }, _this.togglePassword = function () {
      return _this.setState({ showPassword: !_this.state.showPassword });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Signup, [{
    key: 'render',
    value: function render() {
      var errorMessage = this.state.errorMessage;
      var _state = this.state,
          emailError = _state.emailError,
          emailErrorTemplateId = _state.emailErrorTemplateId,
          emailErrorTemplateValues = _state.emailErrorTemplateValues;
      var _state2 = this.state,
          passwordError = _state2.passwordError,
          passwordErrorTemplateId = _state2.passwordErrorTemplateId,
          passwordErrorTemplateValues = _state2.passwordErrorTemplateValues;
      var _state3 = this.state,
          firstNameError = _state3.firstNameError,
          firstNameErrorTemplateId = _state3.firstNameErrorTemplateId,
          firstNameErrorTemplateValues = _state3.firstNameErrorTemplateValues;
      var _state4 = this.state,
          lastNameError = _state4.lastNameError,
          lastNameErrorTemplateId = _state4.lastNameErrorTemplateId,
          lastNameErrorTemplateValues = _state4.lastNameErrorTemplateValues;
      var _props = this.props,
          messages = _props.messages,
          signingUp = _props.signingUp,
          guestBooking = _props.guestBooking,
          guestBookingPromo = _props.guestBookingPromo,
          prefilledInfo = _props.prefilledInfo,
          sessionData = _props.sessionData,
          withPromo = _props.withPromo,
          settingSessionData = _props.settingSessionData,
          loadingSessionData = _props.loadingSessionData,
          oldPromo = _props.oldPromo,
          discount = _props.discount,
          enabledLogins = _props.enabledLogins,
          locale = _props.locale,
          allowGuest = _props.allowGuest;

      var promoLoaderImage = require('theme/images/ajax-loader.gif');
      var defaultEmail = window && window.document && window.document.cookie && _cookie2.default.parse(window.document.cookie).cust_email || '';
      var enableRedirectLogin = (0, _helpers.isMobile)() ? this.props.mobileRedirectLogin : this.props.desktopRedirectLogin;
      return _react3.default.createElement(
        'div',
        { 'data-tmt': 'signup', styleName: 'main-container' },
        allowGuest ? _react3.default.createElement(
          'h3',
          { styleName: 'sub-header' },
          'Let us know how to get back to you'
        ) : _react3.default.createElement(
          'h2',
          { styleName: 'header' },
          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'signup.header' }),
          oldPromo && sessionData && sessionData.redeem && (0, _keys2.default)(sessionData.redeem).length > 0 && _react3.default.createElement(
            'span',
            null,
            ' & Get',
            ' ',
            sessionData.redeem.percentage > 0 ? sessionData.redeem.percentage * 100 + '% OFF' : sessionData.redeem.constant + ' ' + (sessionData.redeem.currency || 'THB')
          ),
          withPromo && discount && _react3.default.createElement(
            'span',
            null,
            ' & Get',
            ' ',
            this.props.discount.startsWith('p') ? this.props.discount.slice(1) + '% OFF' : this.props.discount.slice(1) + ' THB'
          )
        ),
        this.props.subTitle && _react3.default.createElement(
          'h3',
          null,
          this.props.subTitle
        ),
        oldPromo && sessionData && sessionData.redeem && sessionData.redeem.code && !this.props.omitCode && _react3.default.createElement(
          'h3',
          null,
          'PROMO: ',
          _react3.default.createElement(
            'span',
            { styleName: 'orange-text' },
            this.props.sessionData.redeem.code
          )
        ),
        guestBookingPromo && _react3.default.createElement(
          'h3',
          null,
          _react3.default.createElement(
            'span',
            { styleName: 'red-text' },
            'Please sign up to use "',
            prefilledInfo && prefilledInfo.promo,
            '" promo code'
          )
        ),
        withPromo && !this.props.omitCode && _react3.default.createElement(
          'div',
          { styleName: 'promo-form' },
          _react3.default.createElement(
            'div',
            { styleName: 'promo-container' },
            _react3.default.createElement(
              'label',
              { styleName: 'promo-label' },
              'Promo'
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'promo-input-container' },
              _react3.default.createElement('input', { styleName: 'custom-input', placeholder: messages['login.insert_promo_here'], onChange: this.onChangePromo, defaultValue: this.props.promoInput }),
              (settingSessionData || loadingSessionData) && _react3.default.createElement('img', { src: promoLoaderImage, width: '24', height: '24', styleName: 'promo-loader', alt: 'promo loader' })
            )
          ),
          sessionData.redeem && (0, _keys2.default)(sessionData.redeem).length > 0 && _react3.default.createElement(
            'p',
            { styleName: 'promo-text' },
            _react3.default.createElement('i', { styleName: 'green-check' }),
            ' Get',
            ' ',
            sessionData.redeem.percentage > 0 ? sessionData.redeem.percentage * 100 + '% OFF' : sessionData.redeem.constant + ' ' + (sessionData.redeem.currency || 'THB')
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'buttons' },
          enabledLogins.indexOf('facebook') >= 0 && !enableRedirectLogin && _react3.default.createElement(_reactFacebookLogin2.default, {
            cssClass: _LoginSignup2.default['btn-facebook'],
            appId: _config2.default.facebookAppId,
            callback: this.facebookCallback,
            scope: 'public_profile, email',
            textButton: messages[allowGuest ? 'dashboard.setting.social.facebook' : 'signup.facebook'] }),
          enabledLogins.indexOf('facebook') >= 0 && enableRedirectLogin && _react3.default.createElement(
            'a',
            { className: _LoginSignup2.default['btn-facebook'], href: 'https://www.facebook.com/v2.10/dialog/oauth?client_id=' + _config2.default.facebookAppId + '&redirect_uri=' + _config2.default.baseURL.en + '/api/session/login/oauth/facebook&state=' + btoa('site:' + window.location.href + ',redirect_uri:' + _config2.default.baseURL.en + '/api/session/login/oauth/facebook') },
            messages[allowGuest ? 'dashboard.setting.social.facebook' : 'signup.facebook']
          ),
          enabledLogins.indexOf('google') >= 0 && !enableRedirectLogin && _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(_reactGoogleLogin2.default, {
              className: _LoginSignup2.default['btn-google'],
              clientId: _config2.default.googleClientId,
              onSuccess: this.googleCallback,
              onFailure: function onFailure() {},
              buttonText: messages[allowGuest ? 'dashboard.setting.social.google' : 'signup.google'] })
          ),
          enabledLogins.indexOf('google') >= 0 && enableRedirectLogin && _react3.default.createElement(
            'a',
            { className: _LoginSignup2.default['btn-google'], href: 'https://accounts.google.com/o/oauth2/v2/auth?client_id=' + _config2.default.googleClientId + '&response_type=code&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile&redirect_uri=' + _config2.default.baseURL.en + '/api/session/login/oauth/google&state=' + btoa('site:' + window.location.href + ',redirect_uri:' + _config2.default.baseURL.en + '/api/session/login/oauth/google') },
            messages[allowGuest ? 'dashboard.setting.social.google' : 'signup.google']
          ),
          enabledLogins.indexOf('weibo') >= 0 && _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(_WeiboButton2.default, {
              className: _LoginSignup2.default['btn-weibo'],
              locale: locale,
              callback: this.weiboCallback
            })
          )
        ),
        _react3.default.createElement(
          'p',
          { styleName: 'or-flex' },
          _react3.default.createElement('span', { styleName: 'line' }),
          _react3.default.createElement(
            'span',
            { styleName: 'or' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'signup.or' })
          ),
          _react3.default.createElement('span', { styleName: 'line' })
        ),
        _react3.default.createElement(
          'form',
          { className: 'signup-form', styleName: 'form', onSubmit: this.handleSubmit },
          _react3.default.createElement(
            'div',
            { styleName: 'input-container' },
            _react3.default.createElement('input', { 'data-tmt': 'email-input', styleName: emailError ? 'custom-input-error' : 'custom-input', placeholder: messages['signup.email.placeholder'], type: 'email', ref: 'email', defaultValue: prefilledInfo ? prefilledInfo.email : defaultEmail }),
            emailError && _react3.default.createElement(
              'p',
              { styleName: 'error', 'data-tmt': 'email-error', 'data-tmt-err': 'true' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: allowGuest ? 'validation.email_guest' : emailErrorTemplateId, values: emailErrorTemplateValues })
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'input-container', style: allowGuest ? { display: 'none' } : null },
            _react3.default.createElement('input', { className: 'first-name-input', styleName: firstNameError ? 'custom-input-2-error' : 'custom-input-2', placeholder: messages['signup.first_name.placeholder'], type: 'text', ref: 'firstname', defaultValue: prefilledInfo && prefilledInfo.firstName || '' }),
            _react3.default.createElement('input', { className: 'last-name-input', styleName: lastNameError ? 'custom-input-2-error' : 'custom-input-2', placeholder: messages['signup.last_name.placeholder'], type: 'text', ref: 'lastname', defaultValue: prefilledInfo && prefilledInfo.lastName || '' })
          ),
          (firstNameError || lastNameError) && _react3.default.createElement(
            'p',
            { styleName: 'error' },
            firstNameError && _react3.default.createElement(_reactIntl.FormattedMessage, { id: firstNameErrorTemplateId, values: firstNameErrorTemplateValues }),
            firstNameError && lastNameError && _react3.default.createElement('br', null),
            lastNameError && _react3.default.createElement(_reactIntl.FormattedMessage, { id: lastNameErrorTemplateId, values: lastNameErrorTemplateValues })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'input-container', style: allowGuest ? { display: 'none' } : null },
            _react3.default.createElement('input', { className: 'password-input', styleName: passwordError ? 'custom-input-error' : 'custom-input', placeholder: messages['signup.password.placeholder'], type: this.state.showPassword ? 'text' : 'password', ref: 'password' }),
            passwordError && _react3.default.createElement(
              'p',
              { styleName: 'error' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: passwordErrorTemplateId, values: passwordErrorTemplateValues })
            ),
            _react3.default.createElement(
              'p',
              { styleName: 'show-password' },
              _react3.default.createElement(
                'a',
                { onClick: this.togglePassword },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: this.state.showPassword ? 'signup.password.hide' : 'signup.password.show' })
              )
            )
          ),
          errorMessage && _react3.default.createElement(
            'p',
            { styleName: 'error', 'data-tmt': 'signup-error', 'data-tmt-err': 'true' },
            errorMessage
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'terms' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'signup.agree.link' }),
            ' ',
            _react3.default.createElement(
              'a',
              { href: 'https://www.takemetour.com/article/terms-conditions-and-disclaimer', target: '_blank', rel: 'noopener noreferrer' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'signup.agree.link.terms_n_conditions' })
            )
          ),
          _react3.default.createElement(
            'button',
            { 'data-tmt': 'btn-signup', type: 'submit', styleName: 'btn-action' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: allowGuest ? 'payment.payment_summary.guest.label' : 'signup.header' })
          )
        ),
        guestBooking && !guestBookingPromo && _react3.default.createElement(
          'div',
          { styleName: 'cancel-container' },
          _react3.default.createElement(
            'span',
            { styleName: 'cancel-signup', onClick: this.continueWithoutPromo },
            'Continue without Signup'
          )
        ),
        guestBookingPromo && _react3.default.createElement(
          'div',
          { styleName: 'cancel-container' },
          _react3.default.createElement(
            'span',
            { styleName: 'cancel-signup', onClick: this.continueWithoutPromo },
            'Continue booking without promo code'
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: signingUp ? 'loader-container' : 'loader-container-hide' },
          _react3.default.createElement(_Loader2.default, null)
        )
      );
    }
  }]);
  return Signup;
}(_react2.Component), _class2.propTypes = {
  user: _react2.PropTypes.object,
  signup: _react2.PropTypes.func,
  facebookLogin: _react2.PropTypes.func,
  googleLogin: _react2.PropTypes.func,
  mobileConnectLogin: _react2.PropTypes.func,
  weiboLogin: _react2.PropTypes.func,
  updateProfile: _react2.PropTypes.func,
  push: _react2.PropTypes.func,
  callback: _react2.PropTypes.func,
  loadUserConfig: _react2.PropTypes.func,
  paymentForm: _react2.PropTypes.bool,
  isLoggedIn: _react2.PropTypes.bool,
  loggedIn: _react2.PropTypes.func,
  signingUp: _react2.PropTypes.bool,
  dtac_mobile: _react2.PropTypes.string,
  promo: _react2.PropTypes.string,
  discount: _react2.PropTypes.string,
  sessionData: _react2.PropTypes.object,
  withPromo: _react2.PropTypes.bool,
  oldPromo: _react2.PropTypes.bool,
  loadSessionData: _react2.PropTypes.func,
  setSessionData: _react2.PropTypes.func,
  setPromoInput: _react2.PropTypes.func,
  promoInput: _react2.PropTypes.string,
  settingSessionData: _react2.PropTypes.bool,
  loadingSessionData: _react2.PropTypes.bool,
  messages: _react2.PropTypes.object,
  enabledLogins: _react2.PropTypes.array,
  locale: _react2.PropTypes.string,
  allowGuest: _react2.PropTypes.bool,
  onSwitchToLogin: _react2.PropTypes.func,
  requestPermission: _react2.PropTypes.func,
  mobileRedirectLogin: _react2.PropTypes.bool,
  desktopRedirectLogin: _react2.PropTypes.bool,
  subTitle: _react2.PropTypes.string,
  omitCode: _react2.PropTypes.bool,
  guestBooking: _react2.PropTypes.bool,
  guestBookingPromo: _react2.PropTypes.bool,
  prefilledInfo: _react2.PropTypes.object
  // isOpenSignup: PropTypes.bool,
  // isOpenLoginSignup: PropTypes.bool,
}, _class2.defaultProps = {
  paymentForm: false,
  onSwitchToLogin: function onSwitchToLogin() {}
}, _temp2)) || _class) || _class));

exports.default = Signup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/Signup.js
// module id = 464
// module chunks = 47